export var ToggleButtonGroupTestIds = {
    /** Test ID to grab the root element */
    ROOT: 'hawkins-toggle-button-group-root',
    /** Test ID to grab one of the toggle button elements */
    ITEM_NTH: 'hawkins-toggle-button-group-item-',
};
